import { render, staticRenderFns } from "./PromotionsSitewideMobile.vue?vue&type=template&id=cbcae5f8&scoped=true"
import script from "./PromotionsSitewideMobile.vue?vue&type=script&lang=js"
export * from "./PromotionsSitewideMobile.vue?vue&type=script&lang=js"
import style0 from "./PromotionsSitewideMobile.vue?vue&type=style&index=0&id=cbcae5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcae5f8",
  null
  
)

export default component.exports